module.exports = __webpack_public_path__ + "static/media/04_atw_weihnachtskarte.191640c7.svg";